import Vue from 'vue'
import Vuex from 'vuex'
import {getProjectRequest, isCurrentProjectRequest} from '@/helpers/projectContext'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		listadoMeetings: {
			status: 99,
			count: 0,
			data: [],
			total_meetings: 0
		},
		listadoMeetingsTotal: 0,
		createMeetingModal: false,
		draftToLoad: null,
		listingOrder: 1,
		selectedType: 2, // 2: Mis Reuniones, 3: Reuniones (Proyecto), 5: Borradores
		currentMeeting: null,
		loadingMeetingList: false,
		loadingVisualizationChanges: [],
	},
	mutations: {
		setListadoMeetings(state, meetings){
			state.listadoMeetings = meetings
			state.listadoMeetingsTotal = meetings.total_meetings || meetings.total || 0
		},
		setCurrentMeeting(state, meeting){
			state.currentMeeting = meeting
		},
		setCreateMeetingModal(state, status){
			state.createMeetingModal = status
			if(!status) state.draftToLoad = null
		},
		setDraftToLoad(state, draft){
			state.draftToLoad = draft
		},
		setSelectedType(state, type){
			state.selectedType = type
		},
		setLoadingMeetingList(state, loading){
			state.loadingMeetingList = loading
		},
		setListingOrder(state){
			let currentStatus = state.listingOrder
			if(currentStatus === 4){
				currentStatus = 1
			}
			else{
				currentStatus++
			}
			state.listingOrder = currentStatus
		},
		addLoadingVisualizationChange(state, meetingId){
			if(!state.loadingVisualizationChanges.includes(meetingId)) state.loadingVisualizationChanges.push(meetingId)
		},
		removeLoadingVisualizationChange(state, meetingId){
			state.loadingVisualizationChanges = state.loadingVisualizationChanges.filter(id => id !== meetingId)
		},
		resetForProject(state){
			state.listadoMeetings = {status: 99, count: 0, data: [], total_meetings: 0}
			state.listadoMeetingsTotal = 0
			state.currentMeeting = null
			state.draftToLoad = null
			state.loadingMeetingList = false
			state.loadingVisualizationChanges = []
			state.createMeetingModal = false
		}
	},
	actions: {
		async getMyMeetings(context, query){
			const request = getProjectRequest(query.project_id)
			// query: { project_id, start_date?, end_date? }
			context.commit('setLoadingMeetingList', true)
			context.commit('setListadoMeetings', { status: 99, count: 0, data: [], total_meetings: 0 })
			const { getMyMeetingsByProject } = await import('@/helpers/api/meetings')
			try{
				const params = { project_id: query.project_id }
				if(query.start_date) params.start_date = query.start_date
				if(query.end_date) params.end_date = query.end_date
				const res = await getMyMeetingsByProject(params)
				if(isCurrentProjectRequest(request.projectId, request.generation) && res && res.code === 200){
					context.commit('setListadoMeetings', {
						status: 1,
						count: res.meetings ? res.meetings.length : 0,
						data: res.meetings || [],
						total_meetings: res.total_meetings || (res.meetings ? res.meetings.length : 0)
					})
				}
			} catch(e){
				// leave as is on error
			} finally {
				if(isCurrentProjectRequest(request.projectId, request.generation)) context.commit('setLoadingMeetingList', false)
			}
		},
		updateMeetingLocally(context, newMeetingData){
			const idx = context.state.listadoMeetings.data.findIndex(m => m.id === newMeetingData.id)
			if(idx !== -1){
				const data = [...context.state.listadoMeetings.data]
				data[idx] = newMeetingData
				context.commit('setListadoMeetings', { status: 1, count: context.state.listadoMeetings.count, data, total_meetings: context.state.listadoMeetings.total_meetings })
			}
		}
	}
})

export default store